import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { useRouter } from 'next/router';
import NavLink from 'components/NavLink';
import routes from './routes';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

/**
 * CoursesLink
 *
 * Specialized course link item.
 */
function CoursesLink({ children, intl, label, style, target, className, toRoute, toUrl, courseName }) {
  const router = useRouter();

  function createLabel() {
    if (!label) {
      return null;
    }
    return intl.formatMessage(label);
  }

  function checkIsUrl(route) {
    const regex = new RegExp('/^(ftp|http|https)://[^ "]+$/');
    return regex.test(route);
  }

  function createUrlResolve() {
    if (toRoute) {
      let routeUrl = '';
      toRoute.forEach((route, index) => {
        if (index % 2 !== 0 && !checkIsUrl(toRoute[0])) {
          routeUrl += '/';
        } else if (
          index !== 0 && index % 2 === 0 && !checkIsUrl(toRoute[0])
        ) {
          routeUrl += '/';
        }
        if (routes[route]) {
          routeUrl += intl.formatMessage(routes[route]);
        } else {
          routeUrl += route;
        }
      });
      return routeUrl;
    }
    if (toUrl) {
      return toUrl;
    }
    return '#';
  }

  if (checkIsUrl(toRoute[0])) {
    return (
      <NavLink
        basePath={publicRuntimeConfig.PUBLIC_URL}
        to={createUrlResolve()}
        className={className}
        target={target}
        style={style}
        withRouter
        data-with-google-events="true"
        data-google-events={JSON.stringify({
          data: {
            action: 'click',
            category: 'Course',
            label: `Course ${courseName} in ${router.route}`,
            value: createUrlResolve()
          }
        })}
      >
        {createLabel()}
        {children}
      </NavLink>
    );
  }

  return (
    <a
      href={createUrlResolve()}
      className={className}
      target={target}
      style={style}
      data-with-google-events="true"
      data-google-events={JSON.stringify({
        data: {
          action: 'click',
          category: 'Course',
          label: `Course ${courseName} in ${router.asPath}`,
          value: createUrlResolve()
        }
      })}
    >
      {children}
    </a>
  );
}

CoursesLink.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  label: PropTypes.object,
  toUrl: PropTypes.string,
  toRoute: PropTypes.array,
  children: PropTypes.node,
  target: PropTypes.string,
  intl: PropTypes.object.isRequired,
  courseName: PropTypes.string
};

export default injectIntl(CoursesLink);
